module.exports = __webpack_public_path__ + "img/Explain-title@2x.c22d4689.png";